import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';
import {
  OFFERING_WISE_REPORT,
  OFFERING_WISE_REPORT_FILTERS,
  OFFERING_WISE_REPORT_EXPORT,
} from '../resources/endPoint';

export const buildProjectServiceApiUrl = (path) => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${path}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${path}`;
};

export const getOfferingWiseReportFilters = (userInfo = null) => {
  return {
    url: OFFERING_WISE_REPORT_FILTERS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    payload: userInfo ? { userInfo } : {},
    service: serviceName.PROJECT_MS,
  };
};

export const getOfferingWiseReportData = (payload) => {
  return {
    url: OFFERING_WISE_REPORT,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    payload,
    service: serviceName.PROJECT_MS,
  };
};

export const getOfferingWiseReportExport = (payload) => {
  return {
    url: OFFERING_WISE_REPORT_EXPORT,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: true,
    payload,
    service: serviceName.PROJECT_MS,
  };
};
